var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.022 5.71L10.438.349A.796.796 0 009.758 0a.806.806 0 00-.678.348L5.496 5.71H1.577a.82.82 0 00-.79 1.039l2.075 7.585a1.64 1.64 0 001.579 1.194h10.636a1.63 1.63 0 001.575-1.199l2.074-7.584a.73.73 0 00.033-.217.82.82 0 00-.818-.818h-3.92zm-6.718 0l2.455-3.6 2.454 3.6H7.304zm2.455 6.546a1.636 1.636 0 11-.001-3.271 1.636 1.636 0 010 3.271z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "b696208cc4138ea7c7e7da468889a516.svg";
export { SvgBasketIcon as ReactComponent };